import React from "react";

const ProductRepairReportField = ({ customerFile }) => {
  return (
    <>
      {customerFile &&
        customerFile.products &&
        customerFile.products.map((product, index) => (
          <div key={index}>{product && product.identification && product.identification.product_type}</div>
        ))}
    </>
  );
};
export default ProductRepairReportField;
